import { render } from "./customer_details.vue?vue&type=template&id=0c67c3ff&scoped=true"
import script from "./customer_details.vue?vue&type=script&lang=js"
export * from "./customer_details.vue?vue&type=script&lang=js"

import "./customer_details.vue?vue&type=style&index=0&id=0c67c3ff&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c67c3ff"]])

export default __exports__